// store/middleware/complexOrderCartCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const complexOrderCartCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith?.("complexOrderCart/")) {
      const state = store.getState().complexOrderCart;

      try {
        const version = getCacheVersion();
        const CACHE_KEY = `complexOrderCart_v${version}`;
        saveToStorage(CACHE_KEY, state);
      } catch (error) {
        // Игнорируем ошибки кэша
      }
    }

    return result;
  };
